/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents an available input type with its identifying and display information.
 */
export interface AvailableInputTypeV0 { 
    /**
     * Unique identifier for the input type.
     */
    id?: number;
    /**
     * The technical name of the input type.
     */
    name?: string;
    /**
     * The human-readable name of the input type.
     */
    displayName?: string;
}

